import utils from '../utils/utils'
import anime from '../libs/anime'
import Hammer from '../libs/hammer'
import globalVar from '../utils/globalVar'

class Home {
  constructor() {
    const tablet = window.matchMedia("(max-width: 1040px)");
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
      loadSlider();
    }

    let initCache = () => {
      cache.page = document.querySelector('.template-home');
      cache.cardSlider = document.querySelectorAll('.cards_container');
      cache.sliderNav = document.querySelectorAll('.slider_nav .dot');

      cache.secVid = document.querySelector('.sec_video');
      cache.popVid = document.querySelector('.popup_vid');
      cache.popVidBtn = document.querySelectorAll('.pop_btn');
      cache.popVidClose = cache.popVid.querySelector('.close_btn');
      cache.popVidBgClose = cache.popVid.querySelector('.bg_close');

      cache.heroEl = document.querySelectorAll('.sec_hero .el');
    };

    let loadSlider = () => {
      if( jQuery( ".home_slider" ).length > 0 ) {      
        jQuery('.home_slider').css('visibility', 'visible');        
        jQuery('.home_slider').slick({
          slide:'li',
          swipe:true,
          arrows:false,
          adaptiveHeight: true,
          touchMove:true,
          dots:true,
          infinite: true,
          centerMode: false,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        });              
      }
      if( jQuery( "#instafeed a" ).length > 0 ) {      
        jQuery('#instafeed').css('visibility', 'visible');        
        jQuery('#instafeed').slick({
          slide:'a',
          swipe:true,
          arrows:false,
          adaptiveHeight: true,
          touchMove:true,
          dots:false,
          infinite: true,
          centerMode: false,
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 4,
          slidesToScroll: 1,
        });              
      }
    }
    let registerEvents = () => {
      for (var i = 0; i < cache.sliderNav.length; i++) {
        cache.sliderNav[i].addEventListener("click", function() {
          cardsSlide(parseInt(this.dataset.index), this.closest('.cards_container'));
        });
      }

      for (var i = 0; i < cache.heroEl.length; i++) {
        cache.heroEl[i].addEventListener("mouseenter", animeEl);
      }


        if(tablet.matches) {

          let hammertime1 = new Hammer(document.querySelector('.sec_shopping .cards_container'));
          hammertime1.on('swipe', function(ev) {
            let parent = ev.target.closest('section').querySelector('.cards_container');
          if(ev.direction == 2) {
            let index = parseInt(parent.dataset.index);
            let dot = parent.querySelectorAll('.dot');
            if(index == parseInt(dot[dot.length-1].dataset.index)) {
              index = 0;
            } else {
              index += 2;
            }
            cardsSlide(index, parent);
          }
          if(ev.direction == 4) {
            let index = parseInt(parent.dataset.index);
            let dot = parent.querySelectorAll('.slider_nav .dot');
            if(index == 0) {
              index = parseInt(dot[dot.length-1].dataset.index)
            } else {
              index -= 2;
            }
            cardsSlideRight(index, parent);
          }
        });

        let hammertime2 = new Hammer(document.querySelector('.sec_fooding .cards_container'));
        hammertime2.on('swipe', function(ev) {
          let parent = ev.target.closest('section').querySelector('.cards_container');
          if(ev.direction == 2) {
            let index = parseInt(parent.dataset.index);
            let dot = parent.querySelectorAll('.dot');
            if(index == parseInt(dot[dot.length-1].dataset.index)) {
              index = 0;
            } else {
              index += 2;
            }
            cardsSlide(index, parent);
          }
          if(ev.direction == 4) {
            let index = parseInt(parent.dataset.index);
            let dot = parent.querySelectorAll('.slider_nav .dot');
            if(index == 0) {
              index = parseInt(dot[dot.length-1].dataset.index)
            } else {
              index -= 2;
            }
            cardsSlideRight(index, parent);
          }
        });
        
        // let hammertimeFeatures = new Hammer(document.querySelector('.with_two_cols.cards_container'));
        // console.log(hammertimeFeatures);
        // hammertimeFeatures.on('swipe', function(ev) {
        //   let parent = ev.target.closest('section').querySelector('.cards_container');
        //   console.log(ev);
          
        //   if(ev.direction == 2) {
        //     let index = parseInt(parent.dataset.index);
        //     let dot = parent.querySelectorAll('.dot');
        //     if(index == parseInt(dot[dot.length-1].dataset.index)) {
        //       index = 0;
        //     } else {
        //       index += 2;
        //     }
        //     cardsSlide(index, parent);
        //   }
        //   if(ev.direction == 4) {
        //     let index = parseInt(parent.dataset.index);
        //     let dot = parent.querySelectorAll('.slider_nav .dot');
        //     if(index == 0) {
        //       index = parseInt(dot[dot.length-1].dataset.index)
        //     } else {
        //       index -= 2;
        //     }
        //     cardsSlideRight(index, parent);
        //   }
        // });

        let hammertime3 = new Hammer(document.querySelector('.sec_qdn .cards_container'));
        hammertime3.on('swipe', function(ev) {
          let parent = ev.target.closest('section').querySelector('.cards_container:not(.no_slide)');
          if(ev.direction == 2) {
            let index = parseInt(parent.dataset.index);
            let dot = parent.querySelectorAll('.dot');
            if(index == parseInt(dot[dot.length-1].dataset.index)) {
              index = 0;
            } else {
              index += 2;
            }
            cardsSlide(index, parent);
          }
          if(ev.direction == 4) {
            let index = parseInt(parent.dataset.index);
            let dot = parent.querySelectorAll('.slider_nav .dot');
            if(index == 0) {
              index = parseInt(dot[dot.length-1].dataset.index)
            } else {
              index -= 2;
            }
            cardsSlideRight(index, parent);
          }
        });

      }

      for (var i = 0; i < cache.popVidBtn.length; i++) {
        cache.popVidBtn[i].addEventListener("click", openPopUp);
      }
      cache.popVidClose.addEventListener("click", closePopUp);
      cache.popVidBgClose.addEventListener("click", closePopUp);
    };



    let animeEl = function() {
      this.removeEventListener("mouseenter", animeEl);
      this.addEventListener("mouseleave", animeOutEl);
      if(this.classList.contains('el1')) {
        anime({
          targets: this,
          translateX: '1.5%',
          scale: 1.1,
          rotate: -10,
          duration: 300,
          easing: 'spring(1, 80, 10, 0)',
        });
      }
      if(this.classList.contains('el2')) {
        anime({
          targets: this,
          translateX: '2%',
          duration: 600,
          easing: 'easeOutCubic',
        });
      }
      if(this.classList.contains('el3')) {
        anime({
          targets: this,
          rotate: 90,
          scale: 1.05,
          duration: 2500,
          easing: 'easeOutCubic',
        });
      }
      if(this.classList.contains('el4')) {
        anime({
          targets: this,
          rotate: 5,
          translateX: '-4%',
          duration: 1000,
          easing: 'easeOutCubic',
        });
      }
    }

    let animeOutEl = function() {
      this.removeEventListener("mouseleave", animeOutEl);
      this.addEventListener("mouseenter", animeEl);
      if(this.classList.contains('el1')) {
        anime({
          targets: this,
          translateX: ['1.5%', '0%'],
          scale: [1.1, 1],
          rotate: [-10, 0],
          duration: 300,
          easing: 'spring(1, 80, 10, 0)',
        });
      }
      if(this.classList.contains('el2')) {
        anime({
          targets: this,
          translateX: ['2%', '0%'],
          duration: 600,
          easing: 'easeOutCubic',
        });
      }
      if(this.classList.contains('el3')) {
        anime({
          targets: this,
          rotate: 0,
          duration: 2500,
          easing: 'easeOutCubic',
        });
      }
      if(this.classList.contains('el4')) {
        anime({
          targets: this,
          rotate: [5, 0],
          translateX: ['-4%', '0%'],
          duration: 1000,
          easing: 'easeOutCubic',
        });
      }
    }



    let cardsSlide = function(index, parent) {

// Slider QDN
      if(parent.classList.contains('qdn_container')) {
        let cIndex = parseInt(parent.dataset.index);
        parent.dataset.index = index;
        let currentDot = parent.querySelector('.slider_nav .dot.active');
        let targetDot = parent.querySelector('.slider_nav .dot'+index);
        let cards = parent.querySelectorAll('.post_card');
        let target = cards[index];
        let current = cards[cIndex];

        currentDot.classList.remove('active');
        targetDot.classList.add('active');

        anime({
          targets: current,
          translateX: ['0', '-65%'],
          opacity: [1, 0],
          duration: 500,
          easing: 'easeOutCubic',
          complete: function() {
            current.style.display = 'none';
          }
        });
        target.style.display = 'block';
        anime({
          targets: target,
          translateX: ['65%', '0%'],
          opacity: [0, 1],
          duration: 500,
          easing: 'easeOutCubic',
        });
      }

// Slider Shopping + Fooding
      else {
        let cIndex = parseInt(parent.dataset.index);
        parent.dataset.index = index;
        let currentDot = parent.querySelector('.slider_nav .dot.active');
        let cards = parent.querySelectorAll('.shop_card');
        let target1 = cards[index];
        let target2;
        if(index+1 < cards.length) {
          target2 = cards[index+1];
        }
        let targetDot = parent.querySelector('.slider_nav .dot'+index);
        let current1 = cards[cIndex];
        let current2;
        if(cIndex+1 < cards.length) {
          current2 = cards[cIndex+1];
        }
        currentDot.classList.remove('active');
        targetDot.classList.add('active');

        anime({
          targets: current1,
          translateX: ['-102%', '-170%'],
          opacity: [1, 0],
          duration: 500,
          easing: 'easeOutCubic',
          complete: function() {
            current1.style.display = 'none';
          }
        });
        if(cIndex+1 < cards.length) {
          anime({
            targets: current2,
            translateX: ['2%', '-55%'],
            opacity: [1, 0],
            duration: 500,
            easing: 'easeOutCubic',
            complete: function() {
              current2.style.display = 'none';
            }
          });
        }

        target1.style.display = 'block';
        anime({
          targets: target1,
          translateX: ['-40%', '-102%'],
          opacity: [0, 1],
          duration: 500,
          easing: 'easeOutCubic',
        });
        if(index+1 < cards.length) {
          target2.style.display = 'block';
          anime({
            targets: target2,
            translateX: ['70%', '2%'],
            opacity: [0, 1],
            duration: 500,
            easing: 'easeOutCubic',
          });
        }
      }
    }






    let cardsSlideRight = function(index, parent) {

// Slider QDN
      if(parent.classList.contains('qdn_container')) {
        let cIndex = parseInt(parent.dataset.index);
        parent.dataset.index = index;
        let currentDot = parent.querySelector('.slider_nav .dot.active');
        let targetDot = parent.querySelector('.slider_nav .dot'+index);
        let cards = parent.querySelectorAll('.post_card');
        let target = cards[index];
        let current = cards[cIndex];

        currentDot.classList.remove('active');
        targetDot.classList.add('active');

        anime({
          targets: current,
          translateX: ['0', '65%'],
          opacity: [1, 0],
          duration: 500,
          easing: 'easeOutCubic',
          complete: function() {
            current.style.display = 'none';
          }
        });
        target.style.display = 'block';
        anime({
          targets: target,
          translateX: ['-65%', '0%'],
          opacity: [0, 1],
          duration: 500,
          easing: 'easeOutCubic',
        });
      }

      // Slider Shopping + Fooding
            else {
              let cIndex = parseInt(parent.dataset.index);
              parent.dataset.index = index;
              let currentDot = parent.querySelector('.slider_nav .dot.active');
              let cards = parent.querySelectorAll('.shop_card');
              let target1 = cards[index];
              let target2;
              if(index+1 < cards.length) {
                target2 = cards[index+1];
              }
              let targetDot = parent.querySelector('.slider_nav .dot'+index);
              let current1 = cards[cIndex];
              let current2;
              if(cIndex+1 < cards.length) {
                current2 = cards[cIndex+1];
              }
              currentDot.classList.remove('active');
              targetDot.classList.add('active');

              anime({
                targets: current1,
                translateX: ['-105%', '-40%'],
                opacity: [1, 0],
                duration: 500,
                easing: 'easeOutCubic',
                complete: function() {
                  current1.style.display = 'none';
                }
              });
              if(cIndex+1 < cards.length) {
                anime({
                  targets: current2,
                  translateX: ['5%', '65%'],
                  opacity: [1, 0],
                  duration: 500,
                  easing: 'easeOutCubic',
                  complete: function() {
                    current2.style.display = 'none';
                  }
                });
              }

              target1.style.display = 'block';
              anime({
                targets: target1,
                translateX: ['-160%', '-105%'],
                opacity: [0, 1],
                duration: 500,
                easing: 'easeOutCubic',
              });
              if(index+1 < cards.length) {
                target2.style.display = 'block';
                anime({
                  targets: target2,
                  translateX: ['-55%', '5%'],
                  opacity: [0, 1],
                  duration: 500,
                  easing: 'easeOutCubic',
                });
              }

            }
          }



    let openPopUp = function() {
      cache.popVid.style.display = "block";
      utils.disableScroll();
      let videoIframe = cache.popVid.querySelector(".video_player iframe");
      let player = new Vimeo.Player(videoIframe);
      anime({
        targets: cache.popVid,
        scale: [0.85, 1],
        opacity: [0, 1],
        duration: 400,
        easing: 'easeOutCubic',
        complete: function() {
          player.play();
        }
      });
    }

    let closePopUp = function() {
      let videoIframe = cache.popVid.querySelector(".video_player iframe");
      let player = new Vimeo.Player(videoIframe);
      anime({
        targets: cache.popVid,
        scale: [1, 0.85],
        opacity: [1, 0],
        duration: 400,
        easing: 'easeOutCubic',
        complete: function() {
          cache.popVid.style.display = "none";
          utils.enableScroll();
          player.pause();
        }
      });
    }

    initFunc();
  };
}
export { Home }
